// Class: openfl.display.IGraphicsStroke

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IGraphicsStroke = function() {}

// Meta

IGraphicsStroke.__name__ = "openfl.display.IGraphicsStroke";
IGraphicsStroke.__isInterface__ = true;
IGraphicsStroke.prototype = {
	
};
IGraphicsStroke.prototype.__class__ = IGraphicsStroke.prototype.constructor = $hxClasses["openfl.display.IGraphicsStroke"] = IGraphicsStroke;

// Init



// Statics




// Export

exports.default = IGraphicsStroke;